import $ from 'jquery';
const shareInfo = {
  title: '凡人修仙傳M-官網-正版授權3D開放世界修仙',
  descript: '凡人修仙傳M：正版IP授權，次時代引擎打造，還原超高自由度的真實修仙世界！',
};
const getLoginStatus = isClean => {
  return new Promise(resolve => {
    FB.getLoginStatus(response => {
      resolve(response.status === 'connected');
    }, isClean);
  });
};

const fbLogin = () => {
  return new Promise(resolve => {
    FB.login(function (response) {
      resolve(response.status === 'connected');
    });
  });
};

const excShare = info => {
  return new Promise(resolve => {
    FB.ui(info, function (res) {
      resolve(res && !res.error_message);
    });
  });
};
const fbShare = async () => {
  let shareUrl = `https://www.blancozone.com/frxx/index.html?cid=share&scid=fb`;
  let picUrl = `https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/1663657676379.png`;
  let info = {
    method: 'share',
    href: `https://gactivityapi.blancozone.com/fbShareCustomize/customizeShare/message/${encodeURIComponent(
        shareInfo.descript
    )}/app_id/528624315193645/share_title/${encodeURIComponent(
        shareInfo.title
    )}/redict_url/${encodeURIComponent(shareUrl)}/pic_url/${encodeURIComponent(
        picUrl
    )}`,
    display: 'popup',
  };
  let checkRes = await getLoginStatus();
  if (!checkRes) {
    await fbLogin();
  }
  await excShare(info);
};
$('.j-fb-share').on('click', async () => {
  await fbShare();
})